<template>
  <div class="doughnut-chart-container">
    <Doughnut
      :chart-options="chartOptions"
      :chart-data="computedChartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="[centerTextPlugin]"
      :width="width"
      :height="height"
    />
    <div class="below-text text-md">
      {{ sub }} out of {{ total }} members have replied
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 176
    },
    height: {
      type: Number,
      default: 176
    },
    total: {
      type: Number,
      default: 0
    },
    sub: {
      type: Number,
      default: 0
    }
  },
  computed: {
    computedChartData () {
      const subPercentage = (this.sub / this.total) * 100
      const remainingPercentage = 100 - subPercentage

      let backgroundColor = []
      if (subPercentage === 0) {
        backgroundColor = ['#FFD5CA', '#FFD5CA']
      } else if (subPercentage === 100) {
        backgroundColor = ['#007D8F', '#007D8F']
      } else {
        backgroundColor = ['#FEDD75', '#FFF7DD']
      }

      return {
        datasets: [
          {
            backgroundColor: backgroundColor,
            data: [subPercentage, remainingPercentage]
          }
        ]
      }
    }
  },
  data () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        borderWidth: 0,
        cutout: 52,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        hover: {
          mode: null
        }
      },
      centerTextPlugin: {
        id: 'centerText',
        beforeDraw: (chart) => {
          const { ctx, width, height } = chart
          const subPercentage = (this.sub / this.total) * 100
          ctx.restore()
          ctx.font = `24px Rubik`
          ctx.textBaseline = 'middle'
          const text = `${subPercentage.toFixed(0)}%`
          const textX = Math.round((width - ctx.measureText(text).width) / 2)
          const textY = height / 2

          ctx.fillText(text, textX, textY)
          ctx.save()
        }
      }
    }
  }
}
</script>

<style scoped>
.doughnut-chart-container {
  position: relative;
  text-align: center;
  margin-bottom: 30px;
}
.below-text {
  margin-top: 30px;
}
</style>
